<div id="interactive-schedule">
  <div class="calendar-block" style="width: 100%; height: 100%">
    <div style="display: flex; flex-direction: column; height: 100%">
      <div class="header-section" style="flex-shrink: 1">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="date-indent" style="padding-top: 20px">
              <h2 class="m-0 p-0">
                <span id="intro-daterange"
                  >{{ minDate | date : 'dd MMM' }} - {{ maxDate | date : 'dd MMM' }}</span
                >
              </h2>
            </div>
          </div>

          <div class="flex-shrink-1">
            <div class="pt-2" style="padding-bottom: 25px; padding-right: 5px">
              <span
                style="
                  display: inline-block;
                  margin-left: 7px;
                  vertical-align: text-bottom;
                  margin-right: 7px;
                "
              >
                <span *ngIf="driverChanges() > 0">
                  {{ pendingChanges }} <strong>unsaved</strong> time changes
                </span>

                <button
                  (click)="undoChanges()"
                  pButton
                  class="btn blue-grey-btn"
                  id="undo-times"
                  *ngIf="pendingChanges > 0"
                  [label]="'Undo Changes'"
                ></button>
                <button
                  (click)="saveChanges()"
                  pButton
                  class="btn green-btn"
                  id="save-times"
                  [disabled]="pendingChanges == 0"
                  [label]="'Save Times'"
                ></button>
              </span>

              <div style="margin-right: 10px; display: inline-block; padding-top: 4px">
                <span *ngIf="enablePostIts">
                  <button
                    class="btn btn-sm"
                    (click)="addPostIt({ startDateTime: null, endDateTime: null })"
                    style="vertical-align: super"
                  >
                    Add Note
                  </button>
                  &nbsp;
                  <h1 (click)="toggleNotes()">
                    <i class="fa fa-sticky-note-o cursor-pointer"></i>
                  </h1>
                  &nbsp;
                </span>
                <h1>
                  <i
                    class="fa fa-question cursor-pointer"
                    (click)="showHelp()"
                    pTooltip="Show help for this screen"
                    id="intro-help"
                  ></i>
                </h1>
                &nbsp;
                <!--
                <h1 (click)="printJobs()"><i class="fa fa-print cursor-pointer"
                                                  pTooltip="Print job list"></i></h1>
                &nbsp;
                -->
                <h1 (click)="showCalendar = true">
                  <i
                    class="fa fa-calendar cursor-pointer"
                    id="intro-calendar"
                    pTooltip="Select the date range"
                  ></i>
                </h1>
                &nbsp;
                <h1 (click)="toggleLayerMode()" pTooltip="Toggle Stacked/Overlay mode for bars">
                  <i class="fa fa-rotate-180 fa-align-left cursor-pointer"></i>
                </h1>
                &nbsp;
                <h1 (click)="zoomDays(false)">
                  <i class="fa fa-search-minus cursor-pointer" pTooltip="See more dates"></i>
                </h1>
                &nbsp;
                <h1 (click)="zoomDays(true)">
                  <i class="fa fa-search-plus cursor-pointer" pTooltip="See fewer dates"></i>
                </h1>
                &nbsp;
                <h1 (click)="toggleHours()">
                  <i
                    class="fa fa-clock-o cursor-pointer"
                    id="intro-clock"
                    pTooltip="Toggle working hours or 24-hour view"
                  ></i>
                </h1>
              </div>
            </div>
            <div class="flex-shrink-1 pr-5 pt-2"></div>
          </div>
        </div>
      </div>

      <div style="flex-grow: 1">
        <div style="display: flex; flex-direction: row; height: 100%">
          <div class="days" style="" *ngIf="supplierIds">
            <div *ngFor="let day of days; let i = index" class="dayItem">
              <div
                class="dayText"
                [pTooltip]="supplierIds.length == 1 ? 'Click date to change availability' : null"
                tooltipStyleClass="xtooltip"
              >
                <span *ngIf="supplierIds.length != 1">{{ day | datex : 'ddd Do' }}</span>

                <span
                  *ngIf="supplierIds.length == 1"
                  id="dayDate-{{ i }}"
                  class="dayDate availability"
                  [class.available]="isSupplierAvailable(day) == true"
                  [class.unavailable]="isSupplierAvailable(day) == false"
                  [class.unknown]="isSupplierAvailable(day) == null"
                  (click)="changeSupplierStatus(day)"
                  >{{ day | datex : 'ddd Do' }}</span
                >

                <br />
                <span class="dayMonth">{{ day | datex : 'MMM' }}</span>
              </div>
            </div>
          </div>

          <div style="flex-grow: 1; position: relative">
            <div style="display: flex; flex-direction: column">
              <div style="flex: 0 0 30px">
                <div class="hours">
                  <div *ngFor="let hour of hourRange" class="hoursItem">
                    {{ hour }}<span class="minutes">:00</span>
                  </div>
                </div>
              </div>

              <div style="flex-grow: 1">
                <div
                  [class]="
                    activeGrid
                      ? 'vertical-lined-box active-grid'
                      : 'vertical-lined-box inactive-grid'
                  "
                ></div>

                <div class="horizontal-lined-box" id="grid" pDroppable="grid">
                  <div
                    class="grid-inner"
                    style="position: relative; height: 100%"
                    id="grid-inner"
                    (dblclick)="addNoteHere($event)"
                  >
                    <ng-container #gridContainer></ng-container>

                    <div id="taskHeightSample" class="taskHeightSample" style="display: none">
                      <div id="taskHeightSampleInner" class="h-100"></div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="
                    (supplierIds == null || supplierIds.length == 0) &&
                    (tasks == null || tasks.length == 0)
                  "
                  class="nothing-selected"
                >
                  No Suppliers / Jobs Selected
                </div>
                <div *ngIf="loadingDrivers" class="nothing-selected">
                  <i class="fa fa-spin fa-spinner fa-15x"></i> Loading Schedule
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="display: none">
      <div id="hourSample" class="hours">
        <div id="hourSampleInner" class="hoursItem"></div>
      </div>
      <div id="daysSample" class="days">
        <div id="daySampleInner" class="dayItem"></div>
      </div>
    </div>

    <!-- Overlapping task popup -->
    <div id="overlappingTasks" *ngIf="showOverlappingTasks && overlappingTasks.length > 0">
      <table style="width: 100%">
        <tr>
          <td style="font-size: 12px">Select task</td>
          <td>
            <div class="text-right">
              <span class="close-popup cursor-pointer" (click)="showOverlappingTasks = false"
                >Close</span
              >
            </div>
          </td>
        </tr>
      </table>
      <div
        *ngFor="let task of overlappingTasks"
        (click)="bringTaskToFront(task.id)"
        class="task-item cursor-pointer"
      >
        {{ task.vehicle.registrationNumber }} {{ task.order.job.jobNumber }}
      </div>
    </div>
  </div>
</div>

<!-- *ngIf="multipleDrivers" -->
<ng-container [ngTemplateOutlet]="legend" [ngTemplateOutletContext]="{ drivers: drivers }">
</ng-container>

<ng-template #legend let-drivers="drivers">
  <div id="legend" cdkDrag [class]="selectedTask != null ? 'bounce' : ''">
    <div *ngIf="loadingDrivers" class="text-center">
      <i class="fa fa-spin fa-spinner"></i> Updating
    </div>
    <div>
      <div *ngFor="let driver of drivers">
        <div
          class="driver-{{ driver.identifier }}"
          [ngClass]="driver.visible ? 'driver-bold' : 'driver-hidden'"
          [tooltipStyleClass]="'cTooltip'"
          [escape]="false"
          [pTooltip]="driverTooltip(driver)"
        >
          <table>
            <tr>
              <td>
                <span *ngIf="selectedTask == null" (click)="toggleDriver(driver)">
                  <span class="cursor-pointer">
                    <div
                      class="colour-block bg"
                      [ngStyle]="{ 'background-color': driver2rgb(driver) }"
                    >
                      {{ driver.tasks.length }}
                    </div>
                    <span class="driver-name">{{ driver.nickName }}</span>
                  </span>
                </span>

                <span *ngIf="selectedTask != null">
                  <span
                    *ngIf="isCapable(driver)"
                    (click)="assignDriver(selectedTask, driver)"
                    class="cursor-pointer"
                  >
                    <div
                      class="colour-block bg"
                      [ngStyle]="{ 'background-color': driver2rgb(driver) }"
                    >
                      {{ driver.tasks.length }}
                    </div>
                    <span class="driver-name">{{ driver.nickName }}</span>
                  </span>

                  <span *ngIf="!isCapable(driver)">
                    <div class="colour-block bg">
                      <i class="fa fa-minus-circle" style="color: #c00"></i>
                    </div>
                    <span class="driver-name">{{ driver.nickName }}</span>
                  </span>
                </span>
              </td>
              <td class="text-right" *ngIf="selectedTask == null">
                <span class="only-driver" (click)="onlyDriver(driver)">only</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #allowedAreaTemplate let-context="context">
  <div class="allowed-times-area area-common" [ngStyle]="context.style"></div>
</ng-template>

<ng-template #unavailableAreaTemplate let-context="context">
  <div class="unavailable-area area-common" [ngStyle]="context.style"></div>
</ng-template>

<ng-template #pickupWindowAreaTemplate let-context="context">
  <div class="pickup-window-area area-common" [ngStyle]="context.style"></div>
</ng-template>

<ng-template #dropoffWindowAreaTemplate let-context="context">
  <div class="dropoff-window-area area-common" [ngStyle]="context.style"></div>
</ng-template>

<ng-template #pickupOutOfBoundsTemplate let-context="context">
  <div class="pickup-outofbounds-area area-common" [ngStyle]="context.style"></div>
</ng-template>

<ng-template #dropoffOutOfBoundsTemplate let-context="context">
  <div class="dropoff-outofbounds-area area-common" [ngStyle]="context.style"></div>
</ng-template>

<ng-template #outOfHoursAreaTemplate let-context="context">
  <div class="weekend-area area-fullheight" [ngStyle]="context.style"></div>
</ng-template>

<ng-template #postItTemplate let-context="context">
  <div class="postit" cdkDrag [ngStyle]="context.style">
    <div style="width: 100%; height: 100%">
      <div
        style="width: 100%; height: 100%; padding: 5px 10px; box-sizing: border-box"
        (click)="editPostIt(context.noteInfo)"
      >
        {{ context.noteInfo.note }}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #tooltipTemplate let-context="context">
  <div
    class="tooltip-popup"
    [id]="'tooltip-popup-' + context.taskInfo.id"
    *ngIf="context && context.taskInfo != null"
  >
    <div class="fromto">
      <table style="width: 100%" (click)="toggleTooltip($event, context.taskInfo)">
        <tbody>
          <tr>
            <td>
              Job: {{ context.taskInfo?.order?.job?.jobNumber }} &nbsp; Order:
              {{ context.taskInfo?.order?.orderNumber }}
            </td>
            <td style="text-align: right">
              <span *ngIf="context.taskInfo?.order?.job?.supplier == null">
                <span class="buy-now-price">{{
                  context.taskInfo?.order?.job?.buyItNowPrice
                    | currency : 'GBP' : 'symbol' : '1.2-2'
                }}</span>
                &nbsp;
              </span>
              <span class="job-vrm">{{ context.taskInfo?.vehicle?.registrationNumber }}</span
              >&nbsp; <i class="fa fa-times-circle"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style="margin-top: 2px; color: yellow; font-size: 10px">
      {{ context.taskInfo?.vehicle?.make }}
      {{ context.taskInfo?.vehicle?.model }}
      ({{ context.taskInfo?.vehicle?.fuelType }})
    </div>

    <div *ngIf="isVME && context.taskInfo?.order?.job?.supplier != null">
      <div class="fromto">
        <strong>Supplier: {{ context.taskInfo.order.job.supplier.name }}</strong>
      </div>
    </div>

    <div *ngIf="context.taskInfo?.driver != null">
      <div class="fromto">
        Driver: {{ context.taskInfo?.driver?.nickName }} (Travel Mode:
        {{
          taskCollectionTravelMode[
            context.taskInfo?.taskSupplierSchedule?.taskCollectionTravelMode
          ]
        }})
      </div>
    </div>

    <div
      *ngIf="
        context.taskInfo?.order?.customer?.handoverTimes &&
        context.taskInfo?.order?.customer?.handoverTimes[0] > 0
      "
    >
      <div>
        Pickup Handover: {{ context.taskInfo.order.customer.handoverTimes[0] / 60 }} minutes
      </div>
    </div>

    <div class="fromto pt-1">
      Pickup:
      {{ context.taskInfo?.pickupLocation?.city || context.taskInfo?.pickupLocation?.postal_town }}
      ({{ context.taskInfo?.pickupLocation?.postcode }})
    </div>

    <div>
      Pickup Window: {{ context.taskInfo?.pickupEarliestDateTime | date : 'HH:mm EEE dd/MM/yy' }} -
      {{ context.taskInfo?.pickupLatestDateTime | date : 'HH:mm EEE dd/MM/yy' }}
    </div>

    <div class="fromto pt-1">
      Dropoff:
      {{ context.taskInfo?.dropoffLocation.city || context.taskInfo?.dropoffLocation?.postal_town }}
      ({{ context.taskInfo?.dropoffLocation?.postcode }})
    </div>

    <div>
      Dropoff Window:
      {{ context.taskInfo?.dropoffEarliestDateTime | date : 'HH:mm EEE dd/MM/yy' }} -
      {{ context.taskInfo?.dropoffLatestDateTime | date : 'HH:mm EEE dd/MM/yy' }}
    </div>

    <div
      *ngIf="
        context.taskInfo?.order?.customer?.handoverTimes &&
        context.taskInfo?.order?.customer?.handoverTimes[1] > 0
      "
    >
      <div>
        Dropoff Handover: {{ context.taskInfo.order.customer.handoverTimes[1] / 60 }} minutes
      </div>
    </div>

    <div class="pt-1 fromto">
      Distance: {{ math.floor(context.taskInfo?.distance / 1609) }} miles &nbsp;

      <span *ngIf="context.taskInfo?.estimateTime != null"
        >Journey Time: {{ context.taskInfo?.estimateTime }}</span
      >
    </div>

    <div class="map pt-1">
      <div *ngIf="!taskMapCode[context.taskInfo.id]" class="pt-4 text-center">
        <i class="fa fa-spin fa-2x fa-spinner"></i>
      </div>
      <img
        [src]="taskMapCode[context.taskInfo.id]"
        *ngIf="taskMapCode[context.taskInfo.id] != undefined"
      />
    </div>
  </div>
</ng-template>

<ng-template #gridItemTemplate let-context="context">
  <ng-container *ngTemplateOutlet="tooltipTemplate; context: { context: context }"></ng-container>

  <div
    class="tooltip-popup"
    id="tooltip-popup-{{ context.taskInfo.id }}"
    *ngIf="context && context.taskInfo"
    (click)="toggleTooltip($event, context.taskInfo)"
  ></div>

  <div
    [id]="context.id"
    longPress
    (mouseLongPress)="longPress(context, mousePosition)"
    cdkDrag
    (cdkDragMoved)="dragMove(context, $event, 'all')"
    (cdkDragReleased)="dragTaskEnd($event, context.id)"
    (cdkDragStarted)="dragTaskStart($event, context)"
    [cdkDragDisabled]="dragDisabled(context)"
    (dblclick)="viewJob(context.taskInfo.order.job.id)"
    class="draggable-container {{ context.id }}"
    (click)="bringTaskToFront(context.taskInfo.id)"
    (mousedown)="mouseDown($event)"
    [ngClass]="{
      'can-move': context.taskInfo.canReschedule,
      'cannot-move': !context.taskInfo.canReschedule,
      'dark-text': context.textStyle == 'dark',
      'light-text': context.textStyle == 'light',
      selected: selectedTask != null && selectedTask.id == context.taskInfo.id,
      'top-layer': topLayer != null && topLayer == context.taskInfo.id
    }"
    [ngStyle]="context.style"
  >
    <div
      class="draggable-item
        hasStart{{ context.hasStart }}
        hasEnd{{ context.hasEnd }}
        driver-{{ context.driver.identifier }} task"
    >
      <div
        class="resizer resizer-left"
        id="resize-left-{{ context.id }}"
        cdkDrag
        (cdkDragMoved)="dragMove(context, $event, 'left')"
        (cdkDragEnded)="dragTaskEnd($event, context.id)"
        (cdkDragStarted)="dragTaskStart($event, context)"
        [cdkDragDisabled]="dragDisabled(context)"
        cdkDragLockAxis="x"
        *ngIf="context.taskInfo.canReschedule && context.hasStart"
      >
        <div [ngStyle]="context.innerStyle" class="resizer-inner resizer-x"><span>. . .</span></div>
      </div>

      <div [ngClass]="context.leftClass" class="left" [ngStyle]="context.leftStyle">
        <div class="flex flex-column left-inner left-icons">
          <div
            (click)="toggleTooltip($event, context.taskInfo)"
            [id]="'show-tooltip-' + context.taskInfo.id"
          >
            <i class="fa fa-info-circle cursor-pointer"></i>
          </div>
          <div *ngIf="!context.taskInfo.canReschedule">
            <i
              class="fa fa-lock"
              [tooltipStyleClass]="'xtooltip'"
              [pTooltip]="
                'Cannot reschedule. Job status: ' + jobStatusName[context.taskInfo.order.job.status]
              "
            ></i>
          </div>
        </div>
      </div>
      <div
        class="inner bg"
        [ngStyle]="context.innerStyle"
        [tooltipStyleClass]="'interactive-schedule-buynow'"
        [ngClass]="{ changed: hasChanged(context.taskInfo) }"
        [tooltipPosition]="'top'"
        [pTooltip]="context.buynowCode"
      >
        <div
          class="pickup-handover"
          [ngStyle]="context.pickupHandoverStyle"
          [tooltipStyleClass]="'xtooltip'"
          *ngIf="context.hasStart"
          [pTooltip]="
            context.handoverInfo != null
              ? 'Pickup Handover ' + context.handoverInfo?.pickupHandoverMinutes + ' minutes (est)'
              : ''
          "
        ></div>
        <div
          class="inner-contents"
          *ngIf="!savingChanges || !hasChanged(context.taskInfo); else showSavingChanges"
        >
          <div class="job-info flex flex-wrap">
            <div>
              <span *ngIf="context.taskInfo.totalTasksInJob > 1">
                {{ context.taskInfo.xOfTotal }}/{{ context.taskInfo.totalTasksInJob }}
              </span>
              <span class="job-vrm">{{ context.taskInfo.vehicle?.registrationNumber }}</span>
              {{ context.taskInfo.order?.job?.jobNumber }}&nbsp;
            </div>
            <div>
              {{ context.taskInfo?.pickupLocation?.city }} ({{
                context.taskInfo.pickupLocation?.postcode
              }}) to {{ context.taskInfo?.dropoffLocation?.city }} ({{
                context.taskInfo.dropoffLocation?.postcode
              }}) ({{ context.taskInfo.distance / 1609 | number : '1.0-0' }}miles -
              {{ estimatedTimeDisplay(context.taskInfo.estimateTime) }} hrs)&nbsp;
            </div>
            <div class="pr-2 pickup-time">
              <i class="fa fa-arrow-up"></i>
              {{
                context.taskInfo.taskSupplierSchedule.specifiedPickUpTime
                  | datex : 'ddd Do MMM HH:mm'
              }}
            </div>
            <div class="dropoff-time">
              <i class="fa fa-arrow-down"></i>
              {{
                context.taskInfo.taskSupplierSchedule.specifiedDropOffTime
                  | datex : 'ddd Do MMM HH:mm'
              }}
            </div>
          </div>
        </div>
        <div
          class="dropoff-handover"
          [ngStyle]="context.dropoffHandoverStyle"
          [tooltipStyleClass]="'xtooltip'"
          *ngIf="context.hasEnd"
          [pTooltip]="
            context.handoverInfo != null
              ? 'Dropoff handover ' +
                context.handoverInfo?.dropoffHandoverMinutes +
                ' minutes (est)'
              : ''
          "
        ></div>
      </div>
      <div [ngClass]="context.rightClass" class="right" [ngStyle]="context.innerStyle">
        <div
          class="flex flex-column right-inner right-icons"
          *ngIf="!context.taskInfo.order.job.supplierId"
        >
          <div (click)="taskSelect($event, context)">
            <i
              class="fa fa-undo cursor-pointer"
              [pTooltip]="'Cancel'"
              *ngIf="
                selectedTask?.order?.supplierId &&
                selectedTask &&
                selectedTask != null &&
                selectedTask.id == context.taskInfo.id
              "
            ></i>
            <i
              class="fa fa-check cursor-pointer"
              [pTooltip]="jobConfirmText"
              *ngIf="
                supplierIds.length > 0 &&
                (selectedTask == null || selectedTask.id != context.taskInfo.id)
              "
            ></i>
          </div>
          <div>
            <i
              class="fa fa-times cursor-pointer"
              [pTooltip]="'Unselect Job'"
              (click)="removeJob($event, context.taskInfo.order.job.id)"
            ></i>
          </div>
        </div>
        <div *ngIf="taskFinished(context)" class="right-inner-center text-center cursor-default">
          <i class="fa fa-flag-checkered" pTooltip="Job Closed/Completed"></i>
        </div>
        <div
          class="flex flex-column right-inner right-inner-center"
          *ngIf="context.taskInfo.order.job.supplierId && context.multipleDrivers == true"
        >
          <div [pTooltip]="'Change driver'">
            <i class="fa fa-user cursor-pointer" (click)="taskSelect($event, context)"></i>
          </div>
        </div>
      </div>
      <div
        class="resizer resizer-right"
        id="resize-right-{{ context.id }}"
        cdkDrag
        cdkDragLockAxis="x"
        (cdkDragEnded)="dragTaskEnd($event, context.id)"
        (cdkDragStarted)="dragTaskStart($event, context)"
        (cdkDragMoved)="dragMove(context, $event, 'right')"
        [cdkDragDisabled]="dragDisabled(context)"
        *ngIf="context.taskInfo.canReschedule && context.hasEnd"
      >
        <div [ngStyle]="context.innerStyle" class="resizer-inner resizer-x"><span>. . .</span></div>
      </div>
      <div
        class="resizer resizer-bottom"
        id="resize-bottom-{{ context.id }}"
        cdkDrag
        cdkDragLockAxis="y"
        (cdkDragMoved)="dragMove(context, $event, 'bottom')"
        [cdkDragDisabled]="dragDisabled(context)"
        (cdkDragEnded)="dragTaskEnd($event, context.id)"
        (cdkDragStarted)="dragTaskStart($event, context)"
        *ngIf="context.taskInfo.canReschedule && context.hasEnd"
      >
        <div [ngStyle]="context.innerStyle" class="resizer-inner resizer-y"><span>. . .</span></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #showSavingChanges>
  <div
    style="
      display: flex;
      height: 100%;
      width: 100%;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    "
  >
    <div class="text-center" style="width: 100%; font-size: 1.5rem">
      <i class="fa fa-spin fa-spinner"></i>
    </div>
  </div>
</ng-template>

<div id="task-height" style="display: none"></div>

<p-dialog
  [(visible)]="supplierChangeDialog"
  header="Changing Supplier"
  [style]="{ width: '500px' }"
>
  <div class="mb-2">
    You have chosen a driver from a different supplier, please give a reason for this change:
  </div>

  <div class="mb-2">
    <p-dropdown
      appendTo="body"
      placeholder="Select a Reason"
      [options]="unassignReasons"
      [(ngModel)]="unassignReasonId"
      autoWidth="false"
      [style]="{ width: '100%' }"
    ></p-dropdown>
  </div>

  <textarea
    [(ngModel)]="unassignComment"
    placeholder="Comment (optional)"
    pInputTextarea
    style="width: 100%; height: 70px"
  >
  </textarea>

  <p-footer>
    <button
      pButton
      class="blue-btn"
      label="Cancel"
      (click)="cancelChangeDriver(selectedTask)"
    ></button>
    <button
      pButton
      class="green-btn"
      label="Save"
      (click)="
        confirmChangeDriver(selectedTask, newDriver.driverId, unassignReasonId, unassignComment)
      "
    ></button>
  </p-footer>
</p-dialog>

<p-dialog [(visible)]="editPostItDialog" header="Edit Note" [style]="{ width: '500px' }">
  <div class="text-center" *ngIf="currentContext?.noteInfo.id != null">
    <textarea style="width: 100%; height: 100%" [(ngModel)]="currentContext.noteInfo.note">{{
      currentContext.noteInfo.note
    }}</textarea>
  </div>
  <div class="text-right">
    <button pButton label="Delete" (click)="deletePostIt(currentNote)"></button>
    <button pButton label="Cancel" (click)="editPostItDialog = false"></button>
    <button pButton label="Update" (click)="saveNoteInfo()"></button>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="confirmAvailabilityDialog"
  header="Confirm Availability"
  [style]="{ width: '500px' }"
>
  <div class="text-center">
    <strong>You have moved this job to a date that you have set as "unavailable"</strong>

    <div class="mt-2">
      <button
        pButton
        class="mt-2"
        label="Accept new date & Change status to Available"
        (click)="availableConfirm(true, true)"
      ></button>
      <button
        pButton
        class="mt-2"
        label="Accept new date & Keep status as Unavailable"
        (click)="availableConfirm(true, false)"
      ></button>
      <button
        pButton
        class="mt-2"
        label="Cancel. Do not move job to new date"
        (click)="availableConfirm(false, false)"
      ></button>
    </div>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="acceptJobDialog"
  [header]="jobConfirmText"
  [style]="{ width: '500px' }"
  [closable]="false"
  [closeOnEscape]="false"
>
  <div *ngIf="selectedTask != null">
    <div class="fromto">
      <table style="width: 100%">
        <tr>
          <td>
            Job: {{ selectedTask?.order?.job.jobNumber }} &nbsp; Order:
            {{ selectedTask?.order?.orderNumber }}
          </td>
          <td style="text-align: right">
            <span class="job-vrm-preview" style="font-weight: bold">{{
              selectedTask?.vehicle?.registrationNumber
            }}</span>
          </td>
        </tr>
      </table>
    </div>

    <div class="fromto mt-2" *ngIf="selectedTask?.order?.job?.supplierId">
      <strong>Supplier: {{ selectedTask?.order?.job?.supplier?.name }}</strong>
    </div>

    <div class="buy-now-price-preview mt-2" style="font-size: 1.2rem; font-weight: bold">
      {{ selectedTask?.order?.job?.buyItNowPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
    </div>

    <div class="fromto mt-2">
      <span *ngIf="selectedTask?.driver?.nickName"
        >Driver: {{ selectedTask?.driver?.nickName }}</span
      >
      <span *ngIf="selectedTask?.taskSupplierSchedule?.taskCollectionTravelMode">
        (Travel Mode:
        {{ taskCollectionTravelMode[selectedTask.taskSupplierSchedule.taskCollectionTravelMode] }})
      </span>
    </div>
    <div class="mt-3">
      Pickup:
      {{ selectedTask?.taskSupplierSchedule?.specifiedPickUpTime | datex : "ddd DD MMM 'YY HH:mm" }}
    </div>
    <div class="fromto mt-1">
      From:
      {{ selectedTask?.pickupLocation?.city || selectedTask?.pickupLocation?.postal_town || '' }}
      ({{ selectedTask?.pickupLocation?.postcode }})
    </div>
    <div class="mt-3">
      Dropoff:
      {{
        selectedTask?.taskSupplierSchedule?.specifiedDropOffTime | datex : "ddd DD MMM 'YY HH:mm"
      }}
    </div>
    <div class="fromto mt-1">
      To:
      {{ selectedTask?.dropoffLocation?.city || selectedTask?.dropoffLocation?.postal_town || '' }}
      ({{ selectedTask?.dropoffLocation?.postcode }})
    </div>
    <div class="fromto mt-2">
      Distance: {{ selectedTask?.distance / 1609 | number : '1.1-1' }} miles &nbsp; Journey Time:
      {{ estimatedTimeDisplay(selectedTask?.estimateTime) }}
    </div>
  </div>

  <p-footer>
    <button
      pButton
      class="blue-btn"
      label="Cancel"
      (click)="hideAcceptJob(false, selectedTask)"
    ></button>
    <button
      pButton
      class="green-btn"
      [label]="jobConfirmText"
      (click)="confirmAcceptJob(selectedTask)"
    ></button>
  </p-footer>
</p-dialog>

<p-dialog [(visible)]="showCalendar" header="Select Date">
  <div style="height: 350px">
    <p-calendar
      dateFormat="dd/mm/YY"
      (onSelect)="newDateChosen($event)"
      [showTime]="false"
      [(ngModel)]="startDate"
      [inline]="true"
    ></p-calendar>
  </div>
</p-dialog>

<p-growl [(value)]="messageService.msgs" [sticky]="true" [immutable]="false"></p-growl>
